/**************
 Global
 ***************/

// root api
const root = `https://rp2shwczn9.execute-api.us-east-1.amazonaws.com/`;

// url params
const urlParams = new URLSearchParams(window.location.search);

// get index of a specific element
function getElIndex(el) {
    let i;
    for (i = 0; el = el.previousElementSibling; i++) ;
    return i;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    // check if formdata has items
    if (formData.items && formData.items.length > 0) {

        // loop through each item in the formdata items array
        for (let i = 0; i < formData.items.length; i++) {
            // get bundle array
            let bundle = variantToBundle[formData.items[i].id];

            // check if this is a bundle
            if (bundle && bundle.length > 0) {
                a
                // save subscription value (maybe null)
                let subscription = formData.items[i].selling_plan;

                // remove this item from the formdata items array
                formData.items.splice(i, 1);

                // loop through each item in the bundle
                for (let j = 0; j < bundle.length; j++) {
                    // add each bundle item to the formdata items array but there are 2 different scenarios
                    // 1. this variants already exists
                    // 2. this variants doesn't exist yet

                    // bundle variant id & bundle quantity
                    let bundleVariantId = bundle[j].id;
                    let bundleQuantity = bundle[j].quantity;

                    // check if this variant already exists in the formdata items array
                    let exists = false;
                    for (let k = 0; k < formData.items.length; k++) {
                        if (formData.items[k].id === bundleVariantId) {
                            // add the quantity to the existing variant
                            formData.items[k].quantity += bundleQuantity;
                            exists = true;
                            break;
                        }
                    }

                    // if the variant deosn't exist, we add it to the formdata items array
                    if (!exists) {
                        formData.items.push({
                            id: bundleVariantId,
                            quantity: bundleQuantity,
                            selling_plan: subscription,
                        });
                    }

                }
            }
        }
    }
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {

            // update cart count
            fetch("/cart.js")
                .then(response => response.json())
                .then(cart => {
                    if (cart.item_count === 0) {
                        document.querySelector("#headerCart").classList.remove("count");
                        document.querySelector("#headerCart").removeAttribute("count")
                    } else {
                        document.querySelector("#headerCart").classList.add("count");
                        document.querySelector("#headerCart").setAttribute("count", cart.item_count)
                    }
                });

            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
}


// print price ($51.27 = 5127)
function price(amount, withoutTrailingZeros = true) {
    let total = (parseFloat(amount) / 100).toFixed(2);
    if (withoutTrailingZeros) {
        return `$${total.replace(".00", "")}`;
    } else {
        return `$${total}`;
    }
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// scroll to url hash
if (urlParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${urlParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (urlParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${urlParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}